import ResultsGrid from './ResultsGrid';

export default ResultsGrid;
